import {Component, Input} from '@angular/core';
import {EducationIdea} from "../../interfaces/education-idea";
import {EducationIdeaStatus} from "../../enums/education-idea-status";

@Component({
  selector: 'brt-education-idea',
  templateUrl: './education-idea.component.html',
  styleUrls: ['./education-idea.component.scss']
})
export class EducationIdeaComponent {

  @Input('data') set setData(data: EducationIdea) {
    this.data = data;

    this.setStatusString();
    // console.log(data);


  }
  data!: EducationIdea;

  statusString = "";

  setStatusString() {
    switch (this.data.status) {
      case EducationIdeaStatus.DONE:
        this.statusString = "Abgeschlossen";
        return;
      case EducationIdeaStatus.PENDING:
        this.statusString = "In Bearbeitung";
        return;
      case EducationIdeaStatus.REJECTED:
        this.statusString = "Abgelehnt";
        return;
    }
  }

}
